import React, {useState, useEffect} from "react";
import {Form } from "react-bootstrap";
import Select from 'react-select';
import {
    calculate,
    countries,
} from "@starberry/react-calculator-stampduty"

import {calculateMonthlyPayment, CalculatorFields} from "../../../common/utils/mortgage"
import {addCommas, numericWithDecimal, removeNonNumeric} from "../../../common/utils/site_utlis"
import {currency} from "../../../common/constant"


const StampDuty = ({price, department, title}) => {
    const options = [
        { value: 'first', label: 'I’m buying my first home' },
        { value: 'home', label: 'I’m buying my home' },
        { value: 'investor', label: 'I’m buying an additional home' },
    ]

    const [calculator_value, setCalculatorValue] = useState({'purchase_price': price, buyerType: 'first'});
    const[stampResult, setStampResult] = useState('');

    const propertyValue = calculator_value.purchase_price;
    const propertyType = department;
    const country = process.env.GATSBY_STAMPDUTY_COUNTRY === "SCOTLAND" ?  countries.SCOTLAND : countries.ENGLAND;
    const buyerType = calculator_value.buyerType;

    useEffect(()=>{
        //console.log("property_type", propertyValue,buyerType,propertyType);
        const stampDuty = calculate(
            propertyValue, propertyType, country, buyerType,
        );
        //console.log("stampDuty", stampDuty);
        setStampResult(stampDuty);

    },[propertyValue, buyerType, propertyType])


    const handleChange = (event, field_name) => {
        if(field_name === "buyerType"){
            setCalculatorValue({...calculator_value, [field_name]: event.value})
        } else{
            setCalculatorValue({...calculator_value, [event.target.name]: numericWithDecimal(event.target.value)})
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'calculator',
            'formType': title,
            'formName': title,
            'formLabel': title
        });

        //console.log("event trigger", title)

    }

    //console.log("stampResult", stampResult)

    let effectiveRate = stampResult?.tax && (stampResult.tax / numericWithDecimal(propertyValue)) * 100
    effectiveRate = new Intl.NumberFormat("en-US", {}).format(effectiveRate);

    var stamp_cal_text = process.env.GATSBY_STAMPDUTY_COUNTRY === "SCOTLAND" ? "LBTT" : "Stamp Duty Calculator"

    return (
        <React.Fragment>
            <div className="tab-wrapper">
                <Form>
                    <Form.Group className="form-wrap">
                        <Form.Label>Price ({currency})</Form.Label>
                        <Form.Control type="text" name="purchase_price" value={addCommas(calculator_value.purchase_price)} onChange={handleChange} maxLength={CalculatorFields.PriceInputMax}/>
                    </Form.Group>
                    <Form.Group className="form-wrap">
                        <Form.Label>Property Type</Form.Label>
                        <Select options={options} name="buyerType" defaultValue={options[0]} placeholder="I’m buying my first home or next home" className="react-select form-control" classNamePrefix="react-select" onChange={(e) => handleChange(e, "buyerType")} />
                    </Form.Group>
                </Form>
                <div className="bottom-content">
                    <div className="sm-info">
                        <span className="time">{stamp_cal_text} Tax: </span> <span className="bold-text">{currency}{stampResult.tax > 0 ? addCommas(stampResult.tax) : 0}</span>                        
                    </div>

                    <div className="stampduty_rate">
                        {stampResult.summaryBands && stampResult.summaryBands.length > 0 && <>
                            <div className="h3">You have to pay {stamp_cal_text}:</div>
                            {stampResult.summaryBands.map((item, index) => {
                                    return <>
                                        <span className="sm-text ml-0">{item.adjustedRate}% between £{item.start > 0 ?addCommas(item.start) : 0} and £{item.bandLimit > 0 ? addCommas(item.bandLimit) : addCommas(item.end)}</span><br />
                                    </>
                                })
                            }
                            <h4 className="mt-3">Your effective {stamp_cal_text} rate is {effectiveRate}% <br />{stampResult.comment}</h4>
                        </>
                        }
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default StampDuty;